import { createFileRoute } from '@tanstack/react-router'
import SettingsSection from '../../../../components/settings/SettingsSection';
import SalesPointsForm from '../../../../components/billings/SalesPointsForm';
import * as React from 'react';
import PageLoader from '../../../../microcomponents/PageLoader';

export const Route = createFileRoute('/_authenticated/settings/sales-points')({
  component: RouteComponent,
  pendingComponent: () => <PageLoader/>
})

function RouteComponent() {
  return(
    <SettingsSection title={'Punti Vendita'}>
      <SalesPointsForm />
    </SettingsSection>
  )
}
